/**
 * Display-only formatter for ISO8601 timestamps from the API.
 * Storage and `<time dateTime>` attributes should keep the raw ISO string.
 */
export function formatLogTimestamp(iso: string): string {
	const date = new Date(iso);
	if (Number.isNaN(date.getTime())) {
		return "-";
	}
	return new Intl.DateTimeFormat(undefined, {
		dateStyle: "medium",
		timeStyle: "short",
	}).format(date);
}
